/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

/**
 * * `pending` - 대기 중
 * `generating` - 메타데이터 생성 중
 * `metadata_ready` - 메타데이터 완료 (검토 대기)
 * `music_generating` - 음악 생성 중
 * `paused` - 일시정지
 * `cancelled` - 취소됨
 * `completed` - 완료
 * `failed` - 실패
 * `published` - 발행됨
 */
export type TrackStatus = (typeof TrackStatus)[keyof typeof TrackStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TrackStatus = {
  pending: "pending",
  generating: "generating",
  metadata_ready: "metadata_ready",
  music_generating: "music_generating",
  paused: "paused",
  cancelled: "cancelled",
  completed: "completed",
  failed: "failed",
  published: "published",
} as const;
